import {
    updateRouteSelectedAssignment
} from '@containers/activity-router/routes/helpers/assignment/assignment-selected/route-assignments-selected';
import { parseActivityKey } from '@containers/activity-router/routes/helpers/keys/key-generator';
import { AssignmentActions } from '@containers/activity-router/routes/helpers/slice/slice.types';
import {
    GetNewCoursesAssignmentActionParams,
    GetNewCoursesCurrentAssignmentParams,
    GetNewCoursesSelectedAssignmentsParams,
    ManageNewCoursesCellAssignmentsSelectedParams,
    ManageNewCoursesSelectedAssignmentsParams,
    UpdateNewCoursesAssignmentsParams
    // eslint-disable-next-line max-len
} from '@containers/activity-router/routes/learn/new-courses/helpers/slice/assignments/selected/new-courses-assignments-selected-helpers.types';

const {
    assign,
    reassign,
    unassign,
    modify
} = AssignmentActions;

function getAssignmentAction ({ currentAssignment }: GetNewCoursesAssignmentActionParams) {
    const isAssignAction =
        !currentAssignment ||
        (!currentAssignment.currentAssignmentId && !currentAssignment.resultAccuracy);

    if (isAssignAction) return [assign];
    if (currentAssignment.currentAssignmentId) return [unassign, modify];
    if (currentAssignment.resultAccuracy) return [reassign];
}

export function getNewCoursesSelectedAssignments ({
    currentAssignment,
    selectedAssignments,
    ...params
}: GetNewCoursesSelectedAssignmentsParams) {
    const assignmentType = getAssignmentAction({ currentAssignment });

    assignmentType?.forEach((assignmentAction) => {
        selectedAssignments = updateRouteSelectedAssignment({
            selectedAssignments,
            assignmentAction,
            ...params
        });
    });

    return selectedAssignments;
}

export function getNewCoursesCurrentAssignment ({
    activityKey,
    studentKey,
    studentAssignments
}: GetNewCoursesCurrentAssignmentParams) {
    const { id } = parseActivityKey(activityKey);
    const selectedAssignment = studentAssignments[studentKey]?.assignments.find((item) =>
        item.questionSetId === id
    ) || null;

    return selectedAssignment || null;
}

export function manageNewCoursesSelectedAssignments ({
    selectedAssignments,
    activityKey,
    studentKey,
    studentAssignments,
    isSelected
}: ManageNewCoursesSelectedAssignmentsParams) {
    const currentAssignment = getNewCoursesCurrentAssignment({
        activityKey,
        studentKey,
        studentAssignments
    });

    selectedAssignments = getNewCoursesSelectedAssignments({
        currentAssignment,
        selectedAssignments,
        activityKey,
        isSelected,
        userProfileId: studentKey
    });

    return selectedAssignments;
}

export function manageNewCoursesCellAssignmentsSelected ({
    activityId,
    activityType,
    student: { userProfileId },
    topicId,
    gridCells,
    selectedAssignments,
    ...params
}: ManageNewCoursesCellAssignmentsSelectedParams) {
    const studentKey = userProfileId.toString();

    if (!activityId) {
        Object.keys(gridCells[userProfileId][topicId]).forEach((activityKey) => {
            selectedAssignments = manageNewCoursesSelectedAssignments({
                selectedAssignments,
                activityKey,
                studentKey,
                ...params
            });
        });
    } else if (activityType !== null) {
        selectedAssignments = manageNewCoursesSelectedAssignments({
            selectedAssignments,
            activityKey: activityId,
            studentKey,
            ...params
        });
    }

    return selectedAssignments;
}

export function updateNewCoursesAssignments ({
    updatedStudentAssignments,
    selectedAssignments,
    gridCells
}: UpdateNewCoursesAssignmentsParams) {
    selectedAssignments = {
        [assign]: {},
        [reassign]: {},
        [unassign]: {},
        [modify]: {}
    };

    Object.keys(gridCells).forEach((studentKey) => {
        Object.keys(gridCells[studentKey]).forEach((topicId) => {
            Object.keys(gridCells[studentKey][topicId]).forEach((activityKey) => {
                selectedAssignments = manageNewCoursesSelectedAssignments({
                    selectedAssignments,
                    activityKey,
                    studentKey,
                    studentAssignments: updatedStudentAssignments,
                    isSelected: gridCells[studentKey][topicId][activityKey].isSelected
                });
            });
        });
    });

    return selectedAssignments;
}
